<template>
  <el-dialog
    append-to-body
    width="900px"
    title="待招人数"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table
      size="mini"
      :data="tableData"
      style="width: 100%; margin-bottom: 10px"
    >
      <el-table-column prop="day" label="工作时间">
        <template #default="{ row }">
          {{
            `${
              row.day ||
              {
                1: "星期一",
                2: "星期二",
                3: "星期三",
                4: "星期四",
                5: "星期五",
                6: "星期六",
                7: "星期天",
              }[row.week]
            }`
          }}
          {{ `${row.start_time}-${row.end_time}` }}
        </template>
      </el-table-column>
      <el-table-column prop="total" label="招聘人数"> </el-table-column>
      <el-table-column prop="apply_total" label="报名人数"> </el-table-column>
      <el-table-column prop="miss_total" label="待招人数" width="180">
        <template #default="scope">
          <el-popover
            :ref="`popoverDom+${scope.$index}`"
            placement="top"
            width="300"
            @show="handlePopover(scope.row, scope.$index)"
            trigger="click"
          >
            <el-form class="staff-from" :model="form.data">
              <el-form-item label="待招人数" prop="num">
                <el-input v-model="form.data.num" clearable></el-input>
              </el-form-item>
            </el-form>
            <el-row type="flex" justify="center">
              <el-button
                type="primary"
                @click="handleEdit(scope.row, scope.$index)"
                >确定</el-button
              >
            </el-row>
            <template #reference>
              <el-button type="text" icon="el-icon-edit">{{
                scope.row.miss_total
              }}</el-button>
            </template>
          </el-popover>
        </template></el-table-column
      >
    </el-table>
    <el-row type="flex" justify="center">
      <el-button type="primary" @click="confimr">确定</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      info: {},
      form: {
        loading: false,
        data: {
          num: "",
        },
      },
      tableData: [],
    };
  },
  created() {},
  methods: {
    getDetail(row, title) {
      this.title = title;
      // this.info = row;
      this.init(row);
    },
    init(row) {
      this.loading = true;
      this.$http
        .get("/admin/job/detail", { params: { id: row.id } })
        .then((res) => {
          if (res.code == 1) {
            this.info = res.data;
            this.tableData = res.data.part_work_hour;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    handlePopover(row, index) {
      this.form.data.num = row.id;
    },

    handlePopover(row, index) {
      this.form.data.num = row.miss_total;
    },
    confimr() {
      let list = this.tableData.map((item) => {
        return {
          ...item,
          total: Number(item.apply_total) + Number(item.miss_total),
        };
      });
      let params = {
        id: this.info.id,
        part_work_hour_json: JSON.stringify(list),
      };
      this.btnLoading = true;
      this.$http
        .post("/admin/job/setPartWorkHour", params)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("修改成功");
            this.$emit("refresh");
            this.toggle(false);
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handleEdit(row, index) {
      row.miss_total = this.form.data.num;
      // 关闭 popover
      this.$refs[`popoverDom+${index}`].doClose();
    },
  },
};
</script>
<style scoped lang="scss">
.custom-desc {
  width: 100%;
}
</style>